export const listingManager = {
  header: {
    title: "Annunci",
    newListingTitle: "Nuovo annuncio",
    reorderExit: "Esci dalla modalità di riordino",
    reorder: "Riordina gli annunci",
    done: "Fatto",
    sort: "Ordina",
    searchPlaceholder: "Cerca…",
    searchClear: "Cancella",
    reorderHint: "Trascina per cambiare l'ordine",
  },
  globalBtn: {
    title: "Impostazioni globali",
    sub: "Identità e nuove prenotazioni · intero account",
  },
  list: {
    of: "di",
    listingSingular: "annuncio",
    listingPlural: "annunci",
    unitSingular: "unità",
    unitPlural: "unità",
    retry: "Riprova",
    noResults: 'Nessun risultato per "{query}"',
    viewUnits: "Visualizza unità",
    loadingUnits: "Caricamento unità…",
    refuerzaA: "Rinforza {name}: per ora raccoglie le sue prenotazioni del canale",
    noUnits: "Nessuna unità",
    dragToMove: "Trascina per spostare",
    unitFallback: "Unità {n}",
  },
  empty: {
    title: "Seleziona un annuncio",
    sub: "Scegli un annuncio dal pannello di sinistra per gestirne le impostazioni.",
  },
  create: {
    title: "Nuovo annuncio",
    subtitle: "Crea un annuncio per raggruppare le tue unità.",
    nameLabel: "Nome dell'annuncio",
    namePlaceholder: "Es. Loft in centro",
    typeLabel: "Tipo di alloggio",
    currencyLabel: "Valuta",
    currencyHint: "La valuta non può essere modificata dopo la creazione dell'annuncio.",
    submit: "Crea annuncio",
    nameRequired: "Il nome è obbligatorio.",
    errorCreate: "Impossibile creare l'annuncio.",
    successCreate: "Annuncio creato con successo.",
  },
  delete: {
    titleListing: "Elimina annuncio",
    titleUnit: "Elimina unità",
    text: "Verrà rimosso da WACheckin. Queste modifiche non possono essere annullate. Per confermare, digita il nome:",
    placeholderListing: "Nome dell'annuncio",
    placeholderUnit: "Nome dell'unità",
    deleting: "Eliminazione…",
    confirm: "Elimina",
    errorDelete: "Impossibile eliminare.",
    successListing: "Annuncio eliminato con successo.",
    successUnit: "Unità eliminata con successo.",
  },
  propertyTypes: {
    apartment: "Appartamento",
    villa: "Villa",
    hotel: "Hotel",
    camping: "Campeggio",
  },
  propertyTypeLabels: {
    apartment: "Appartamento",
    house: "Casa",
    villa: "Villa",
    hotel: "Hotel",
    room: "Camera",
    studio: "Monolocale",
    fallback: "Alloggio",
  },
  toast: {
    errorLoad: "Errore durante il caricamento degli annunci.",
    orderSaved: "Ordine salvato con successo.",
    errorOrder: "Impossibile salvare l'ordine.",
    nameUpdated: "Nome aggiornato.",
    errorName: "Impossibile aggiornare il nome.",
  },
  common: {
    cancel: "Annulla",
  },
  globalConfig: {
    hero: {
      title: "Impostazioni globali",
      subPre: "Impostazioni dell'Agente IA che si applicano a",
      subStrong: "tutti i tuoi alloggi",
      subPost: ".",
    },
    waba: {
      checking: "Verifica della connessione…",
      connected: "Collegato",
      start: "Inizia qui",
      titleConnected: "WhatsApp Business",
      titleDisconnected: "Collega WhatsApp Business",
      checkingSub: "Verifica dello stato del tuo numero…",
      numberPrefix: "Numero",
      verified: "verificato e pronto per l'invio ✓",
      pending: "in attesa di verifica",
      linked: "Il tuo account WhatsApp Business è collegato.",
      linkPrompt: "Collega il tuo numero affinché l'agente possa rispondere e scrivere ai tuoi ospiti su WhatsApp.",
      manage: "Gestisci",
      connect: "Collega",
    },
    sectionLabel: "Generale · intero account",
    badgeDefault: "IA ✨",
    requiresWaba: "Richiede WhatsApp Business collegato",
    notContracted: "Non incluso nel tuo piano. Scrivici per attivarlo.",
    cards: {
      general: {
        title: "Impostazioni generali",
        sub: "Identità e stile dell'agente",
      },
      newBookings: {
        title: "Nuove prenotazioni",
        sub: "Primo contatto, domande e link di prenotazione",
      },
      voiceAgent: {
        title: "Agente IA vocale",
        sub: "Risponde alle chiamate telefoniche",
        badge: "NUOVO",
      },
    },
    foot: {
      pre: "Queste impostazioni sono",
      strong: "esclusive del tuo account",
      post: ": modificandole qui vengono applicate automaticamente a tutti gli annunci. Il resto della configurazione (check-in, accesso, prezzi…) rimane per singolo annuncio.",
    },
  },
};
